export default class AllThatRollupDto {
  constructor(options = {}) {
    this.totalClients = options.totalClients || 0;
    this.totalService = options.totalService || 0;
    this.academicHours = options.academicHours || 0;
    this.careerHours = options.careerHours || 0;
    this.lifeSkillsHours = options.lifeSkillsHours || 0;
    this.currentEnrollments = options.currentEnrollments || 0;
    this.newEnrollments = options.newEnrollments || 0;
    this.unenrollments = options.unenrollments || 0;

    this.locations = options.locations || [];
    this.categories = options.categories || [];

  }

  stringify() {
    return JSON.stringify(this);
  }
}
